module.exports = __webpack_public_path__ + "static/media/pokedex_img.fadbc1a1.png";